import './atm-locations.scss';

import AtmLocationsFunctional from './components/AtmLocationsFunctional';
import React from 'react';
import reducer from './reducer';
import sagas from './sagas';
import { withReducer } from '@store/reducerLoader';

const AtmLocations = () => {
	return <AtmLocationsFunctional />;
};

const ReducedScreen = withReducer('atmlocations', reducer, sagas)(AtmLocations);
export default ReducedScreen;






